import { createSelector } from '@ngrx/store';
import { getJobState } from '../store/store.selectors';
import { JobStateInterface, selectAll } from './job.state';

export const getAllJobs = createSelector(
  getJobState,
  (state: JobStateInterface) => selectAll(state)
);
